export default "__VITE_ASSET__172a5d17__"